import React, { useEffect, useState } from 'react'
import { IoIosArrowDown } from "react-icons/io";
import { MdOutlineRadioButtonChecked } from "react-icons/md";
import { MdRadioButtonUnchecked } from "react-icons/md";
import NodeaxiosInstance from '../../Services/nodeaxios';
import { useSelector } from 'react-redux';


const VendorCategorieList = ({ setCategorieData, fromPage }) => {

    const [fil_type, set_fil_type] = useState(0);
    const [openDropdown, setOpenDropdown] = useState(null);
    const [isModelOpen, setIsModalOpen] = useState(false)
    const [selectedcata, setSelectedcate] = useState('all')
    const [selectedCategoryName, setSelectedCategoryName] = useState("");
    const [vendorTypes, setVendorTypes] = useState([]);
    const [searchHistoryList, setSearchHistoryList] = useState([]);
    const state = useSelector((state) => state);
    const [userData, serUserData] = useState(state?.userAuth?.user);

    useEffect(() => {
        const fetchData = async () => {
            try { 
                sessionStorage.removeItem("membership");

                const filterRes = await NodeaxiosInstance.get("/search-filter", {
                    headers: {
                        Authorization: userData?.token,
                    },
                });

                const updatedVendorTypes = filterRes.data.vendor_type.map((item) => ({
                    ...item,
                    isSelected: false,
                }));

                setVendorTypes(updatedVendorTypes);

                // getRecentSearchHistory();
            } catch (error) {
                if (error.response?.status == 403) {
                    console.error("Forbidden - token might be invalid or expired");
                }
            }
        };

        fetchData();
    }, []);
 


    return (
        <div>

            <div className="searchFilter d-flex scroller-style-x mt-2 mb-2">

                {/* 🔹 RECENT BUTTON (Manual) */}
                {
                    fromPage == 'memberShipSearch' || fromPage == 'offerShipSearch' ?
                        "" :
                        <div className={`d-flex align-items-center  ${fil_type == -1 ? "seletedcategorie" : "vendorTypebox"}`}
                            role="button"
                            onClick={() => {
                                set_fil_type(-1);
                                setOpenDropdown(null);
                                setIsModalOpen(false);
                                setSelectedcate("Recent");
                                setSelectedCategoryName("Recent");

                                setCategorieData({
                                    vendor_type_id: -1,
                                    vendor_type_name: "Recent",
                                    vendor_category_id: "",
                                    vendor_category_name: ""
                                });
                            }}
                        >
                            Recent
                        </div>
                }


                {vendorTypes.map((item) => {
                    const isActive = fil_type == item.vendor_type_id;
                    const hasMultipleCats = item.vendor_categories.length > 1;

                    return (
                        <React.Fragment key={item.vendor_type_id}>

                            <div className={`d-flex align-items-center  ${isActive ? "seletedcategorie" : "vendorTypebox"}`} role="button"
                                onClick={() => {
                                    set_fil_type(item.vendor_type_id);
                                    setSelectedcate("all");
                                    setSelectedCategoryName("");

                                    if (hasMultipleCats && fromPage == 'vendorSearch' ) {
                                        if (selectedCategoryName) {
                                            setOpenDropdown(item.vendor_type_id)
                                        }
                                        else {
                                            setOpenDropdown(openDropdown == item.vendor_type_id ? null : item.vendor_type_id
                                            );
                                        }
                                        setIsModalOpen(true);
                                    } else {
                                        setOpenDropdown(null);
                                        setIsModalOpen(false);
                                    }
                                    setCategorieData({
                                        vendor_type_id: item.vendor_type_id,
                                        vendor_type_name: item.vendor_type_name,
                                        vendor_category_id: item?.vendor_category_id,
                                        vendor_category_name: item.vendor_type_name
                                    });
                                }}
                            >
                                {openDropdown === item.vendor_type_id && selectedCategoryName ? selectedCategoryName : item.vendor_type_name}

                                {hasMultipleCats && fromPage == 'vendorSearch' && (
                                    <IoIosArrowDown size={18} className="ms-2" />
                                )}
                            </div>

                            {openDropdown === item.vendor_type_id && isModelOpen && (
                                <>
                                    <div className="modal-backdrop fade show" ></div>
                                    <div className="vendorcategoriesBox">
                                        <div
                                            className="vendorcategoriesList"
                                            onClick={() => {
                                                setSelectedcate("all");
                                                setSelectedCategoryName(item.vendor_type_name);
                                                setIsModalOpen(false);

                                                setCategorieData({
                                                    vendor_type_id: item.vendor_type_id,
                                                    vendor_type_name: item.vendor_type_name,
                                                    vendor_category_id: "",
                                                    vendor_category_name: item.vendor_type_name
                                                });
                                            }}
                                        >
                                            All
                                            {selectedcata === "all" ? (
                                                <MdOutlineRadioButtonChecked size={16} color="#4E26A3" />
                                            ) : (
                                                <MdRadioButtonUnchecked size={16} />
                                            )}
                                        </div>

                                        {/* CATEGORY LIST */}
                                        {item.vendor_categories.map((cat) => (
                                            <div
                                                key={cat.vendor_category_id}
                                                className="vendorcategoriesList"
                                                onClick={() => {
                                                    setSelectedcate(cat.vendor_category_id);
                                                    setSelectedCategoryName(cat.vendor_category_name);
                                                    setIsModalOpen(false);

                                                    setCategorieData({
                                                        vendor_type_id: item.vendor_type_id,
                                                        vendor_type_name: item.vendor_type_name,
                                                        vendor_category_id: cat.vendor_category_id,
                                                        vendor_category_name: cat.vendor_category_name
                                                    });
                                                }}
                                            >
                                                {cat.vendor_category_name}

                                                {cat.vendor_category_id === selectedcata ? (
                                                    <MdOutlineRadioButtonChecked size={16} color="#4E26A3" />
                                                ) : (
                                                    <MdRadioButtonUnchecked size={16} />
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </>
                            )}
                        </React.Fragment>
                    );
                })}
            </div>


        </div >
    )
}

export default VendorCategorieList